// PersonaZone, German. The persona vocabulary lives here because the zone is on the Person page
// and, one day, anywhere a person is read.
import { registerDe } from '../i18n/index.js';

registerDe({
  'Persona': 'Persona',
  'synthesised from the held interactions, the mail and the dossier':
    'synthetisiert aus den übernommenen Kontakten, den Mails und dem Dossier',
  'version {n} · {status} · every trait carries a verbatim quote':
    'Version {n} · {status} · jedes Merkmal trägt ein wörtliches Zitat',
  'Synthesise': 'Synthetisieren',
  'Starting…': 'Wird gestartet…',
  'loading…': 'wird geladen…',
  'The persona could not be read: {error}': 'Die Persona konnte nicht gelesen werden: {error}',
  '{ref} started. It reads the record and files a proposal; nothing is written until you hold it.':
    '{ref} gestartet. Der Lauf liest den Bestand und reicht einen Vorschlag ein; geschrieben wird nichts, bis Sie ihn übernehmen.',
  '{ref} is running. When it finishes, its persona waits in Review.':
    '{ref} läuft. Wenn er fertig ist, wartet seine Persona in der Prüfung.',
  'Could not start the run.': 'Der Lauf konnte nicht gestartet werden.',
  'No persona yet. Synthesise reads the held interactions, the mail and the dossier and proposes traits — topics, style, decision role, objections, register, timing — each carrying at least one verbatim quote. A trait without a quote is dropped before the proposal is filed, and the proposal is held in Review like any other.':
    'Noch keine Persona. «Synthetisieren» liest die übernommenen Kontakte, die Mails und das Dossier und schlägt Merkmale vor — Themen, Stil, Entscheidungsrolle, Einwände, Anredeform, Timing — jedes mit mindestens einem wörtlichen Zitat. Ein Merkmal ohne Zitat wird verworfen, bevor der Vorschlag eingereicht wird, und der Vorschlag wird wie jeder andere in der Prüfung übernommen.',
  'Hide quotes': 'Zitate ausblenden',
  '{n} quotes': '{n} Zitate',
  'no quote': 'kein Zitat',
  'no source named': 'keine Quelle genannt',
  'filed by': 'eingereicht von',
  'Hold it in Review': 'In der Prüfung übernehmen',

  // trait keys
  'Topics': 'Themen',
  'Style': 'Stil',
  'Decision role': 'Entscheidungsrolle',
  'Objections': 'Einwände',
  'Register': 'Anredeform',
  'Timing': 'Timing',

  // evidence kinds
  'interaction': 'Kontaktpunkt',
  'document': 'Dokument',
  'snapshot': 'Snapshot',
  'url': 'URL',
  'manual': 'manuell',
}, 'PersonaZone');
